import React, { Component,Fragment } from 'react';
import Breadcrumb from '../../common/breadcrumb';
import moment from "moment/moment";
import {ChatCard} from "./chat-card";
import {Button1} from "../../Perusahaan/components/Button/button";
import ChatScrollList from "../chat-scroll"
import customToast from "../../../notification/customToast";
import {connect} from "react-redux";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {MESSAGE_COMPANY_ID} from "../../../helper/host";
import "react-image-lightbox/style.css";
import 'moment/locale/id'
import "../style.css";
import {clear_auth, set_auth} from "../../../reducers/Auth";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {HttpClient} from "../http-client"
import {CreateWebSocket} from "../web-socket";
import { AsyncPaginate } from 'react-select-async-paginate';
import search from "../../../assets/icon/search.svg";
import Spin from "antd/es/spin";
import Modal from '../../../components/Perusahaan/components/Modal'

export class ChatMitra extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataCompany     : [],
            companyList     : [],
            dataConversation: [],
            dataImage       : [],
            dataChannelsId  : [],
            select_company  : null,
            selectedCompany : null,
            search          :'',
            currentPage     : 0,
            auth            : props.auth,
            loading         : true,
            savedToken      : localStorage.getItem("Presensi-message-token"),
            modalNewChat    : false,
            addChat         : false,
            chatActive      : false,
            userActive_id           : null,
            userActive_status       : '',
            userActive_archived     : '',
            userActive_isOnline     : false,
            userActive_lastChatDate : '',
            dataParticipants: [],
            cleanChatRef    : null,
            conversations   : [],
            conversation    : [],
            messageAccount  : {},
            socketChatsFn   : null,
            messagesData    : [],
            text            : ' ',
            image           : {},
            fileList        : [],
            perusahaan_id   : "",
            perusahaan_nama : "",
            perusahaan_email: "",
            perusahaan_foto : [],
            randomNumber    : null,
            name            : "",
            email           : "",
            password        : "",
            customerId      : "",
            customerCode    : "",
            credential      : "",
            companyID       : "",
        }

        this.handleChange           = this.handleChange.bind(this)
        this.handleSearchKeyword    = this.handleSearchKeyword.bind(this)
        this.handleOpenChat         = this.handleOpenChat.bind(this)
        this.handleCloseChat        = this.handleCloseChat.bind(this)
        this.socketConversation     = this.socketConversation.bind(this);
        this.socketChats            = this.socketChats.bind(this);
        this.getMessageToken        = this.getMessageToken.bind(this);

        this.cleanChatRef           = React.createRef()
        this.socketRef              = React.createRef();
        this.retryCountRef          = React.createRef();

        this.pingIntervalRef        = React.createRef();
        this.retryCountRef.current  = 0;
        this.maxRetries             = 5;

        this.retryDelay             = 5000;
        this.lastSocketId           = null;
    }

    generateRandom = () => {
        const random = Math.floor(10000 + Math.random() * 90000);
        this.setState({
            randomNumber: random
        });
    }

    getMessageToken = () => {
        const reqData = {
            email: "presensi.co.id@gmail.com",
            password: "123",
        };

        HttpClient("/customers/login", "POST", reqData)
            .then((login) => {
                if (login?.success && login.token) {
                    localStorage.setItem("Presensi-message-token", login.token);
                    localStorage.setItem("Presensi-message-user", JSON.stringify(login.data));
                    this.initChatApp(login.token, login.data);
                    this.socketConversation(login.token);
                } else {
                    console.error("Login failed:", login?.message || "Unknown error");
                }
            })
            .catch((error) => {
                console.error("Error during login:", error);
            });
    };

    getChannels() {
        HttpClient(`/channels?companyID=${MESSAGE_COMPANY_ID}`, "GET")
            .then(response => {
                if (response.success && response.channels.length > 0) {
                    const channelIds = response.channels.map(channel => channel._id);
                    this.setState(
                        { dataChannelsId: channelIds },
                        () => this.getConversation()
                    );
                }
            });
    }

    getConversation() {
        const page = 1;
        const channelID = this.state.dataChannelsId[0];
        const search = this.state.search;

        const queryParams = new URLSearchParams({
            page,
            channel: channelID,
            search
        });

        HttpClient(`/conversation?${queryParams.toString()}`, "GET")
            .then(response => {
                if (response.success) {
                    const filteredData = response.data.filter(
                        (conversation) => conversation.participants.length > 1
                    );

                    this.setState((prevState) => ({
                        conversations: page === 1
                            ? filteredData
                            : [...prevState.conversations, ...filteredData],
                        dataConversation    : response.data,
                        page                : 1,
                        loading             : false
                    }));
                }
            });
    }

    loadDetail(itemId) {
        let formData = {
            id: itemId,
            auth: this.props.auth
        };

        this.props.request("admin/perusahaan/detail", formData)
            .then((response) => {
                if (response.success) {
                    var result = response.data;
                    var paket = response.paket;
                    var perusahaan_paket = result.langganan && paket.filter(
                        (paket) => paket.paket_id === result.langganan.paket_id
                    )[0]

                    this.setState({
                        dataCompany: result,
                        Paket: paket,
                        modal: false,
                        loading: false,
                        perusahaan_paket_nama: perusahaan_paket && perusahaan_paket.paket_nama,
                        perusahaan_foto: result.perusahaan_foto,
                        perusahaan_id: result.perusahaan_id,
                        perusahaan_nama: result.perusahaan_nama,
                        perusahaan_alamat: result.perusahaan_alamat,
                        perusahaan_telp: result.perusahaan_telp,
                        perusahaan_bidang: result.perusahaan_bidang,
                        perusahaan_email: result.perusahaan_email,
                        perusahaan_user: result.perusahaan_user,
                        created_at: result.created_at,
                        updated_at: result.updated_at,
                        langganan_status: result.langganan ? result.langganan.langganan_status : '-',
                        langganan_metode_bayar: result.langganan ? result.langganan.langganan_metode_bayar : '-',
                        karyawan_count: result.karyawan_count,
                        lokasi_count: result.lokasi_count,
                        status: result.status,
                    });
                }
            });
    }

    loadCompanyOptions = async (search, loadedOptions, { page }) => {
        const formData = {
            perusahaan_id           : null,
            page                    : page,
            paging                  : 20,
            keyword                 : search
        };

        try {
            const response = await this.props.request('admin/perusahaan/list', formData, 'POST');

            if (response.success) {
                const result = response.data;

                const options = result.data.map(item => ({
                    value: item.perusahaan_id,
                    label: item.perusahaan_nama
                }));

                return {
                    options,
                    additional: {
                        page: page + 1
                    }
                };
            }

            return {
                options: [],
                additional: {
                    page: page
                }
            };
        } catch (error) {
            console.error("Load options error:", error);
            return {
                options: [],
                additional: {
                    page: page
                }
            };
        }
    };

    handleOpenChat() {
        this.setState({
            chatActive: true
        })
    };

    handleCloseChat() {
        this.setState({
            addChat: false,
            chatActive: false,
            userActive_id: ''
        })
    };

    toggleModal() {
        this.setState({
            modalNewChat    : false,
            select_company  : null,
            selectedCompany : null,
            perusahaan_id   : "",
            perusahaan_nama : "",
            perusahaan_email: "",
            perusahaan_foto : [],
        })
    };

    registerCustomer = () => {
        const { perusahaan_id, perusahaan_nama, perusahaan_email, randomNumber } = this.state;
        const formData = {
            name: perusahaan_nama,
            email: perusahaan_email,
            password: "123",
            customerId: "20" + perusahaan_id,
            customerCode: "20" + perusahaan_id,
            credential: "user",
            companyID: MESSAGE_COMPANY_ID,
        }

        HttpClient("/customers", "POST", formData)
            .then((response) => {
                if (response.success) {
                    this.createConversation()
                }
            })
            .catch((error) => {
                const msg = error?.message || "";

                if (msg.includes("Customers already exists")) {
                    this.createConversation()
                } else {
                    customToast.error(`Tidak dapat membuat percakapan dengan "${perusahaan_nama}".`);
                }

                this.toggleModal();
            });
    }

    createConversation = () => {
        const { perusahaan_nama, perusahaan_email, dataChannelsId, savedToken } = this.state;

        const formData = {
            emailTarget : perusahaan_email,
            channelID   : dataChannelsId[0],
            namespace   : ' ',
            title       : perusahaan_nama,
            lastChat    : ' ',
            companyID   : MESSAGE_COMPANY_ID,
        };

        this.setState({ isSending: true });

        HttpClient("/conversation", "POST", formData)
            .then((response) => {
                if (response.success) {
                    const conversation = response.data;

                    const nonAdminParticipants = conversation.participants.find(
                        (member) => member.credential === "user"
                    );

                    this.setState({
                        userActive_id           : conversation._id,
                        userActive_status       : 'new',
                        userActive_archived     : false,
                        userActive_isOnline     : false,
                        userActive_lastChatDate : ' ',
                        dataParticipants        : conversation.participants,
                        chatActive              : true
                    });

                    this.toggleModal();
                    this.handleConversationClick(conversation, nonAdminParticipants);
                    this.socketChats(conversation._id, savedToken);
                    this.socketConversation(savedToken);
                }
            })
            .catch((error) => {
                const msg = error?.message || "";

                if (msg.includes("Conversation already exists")) {
                    customToast.error(`Percakapan dengan "${perusahaan_nama}" sudah tersedia.`);
                } else {
                    customToast.error(`Tidak dapat membuat percakapan dengan "${perusahaan_nama}".`);
                }

                this.toggleModal();
            });
    };

    handleChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            currentPage : 0,
            [name]: value
        })
    }

    handleSearchKeyword(event) {
        const value = event.target.value;

        this.setState({
            currentPage: 0,
            search: value
        });
    }

    handleSearchKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.getConversation();
            this.setState({
                loading: true
            });
        }
    };

    handleConversationClick(conversation, nonAdminParticipants) {
        this.setState({
            userActive_id: conversation._id,
            userActive_status: conversation.status,
            userActive_archived: conversation.isArchived,
            userActive_isOnline: nonAdminParticipants?.isOnline || false,
            userActive_lastChatDate: conversation.lastChatUpdate,
            dataParticipants: conversation.participants
        }, async () => {

            const sender = conversation.participants.find(p => p.role === "sender");
            const senderId = sender?.userID || "";
            this.setState({ typingSender: senderId });

            setTimeout(async () => {
                if (conversation.status === "new") {
                    await this.handleChangeStatus(conversation._id);
                }
                await this.handleReadMessage(conversation._id);
                await this.handleChangeOnline(conversation._id, true);
            }, 100);

            if (this.state.socketChatsFn && this.lastSocketId !== conversation._id) {
                this.state.socketChatsFn(conversation._id, localStorage.getItem("Presensi-message-token"));
                this.lastSocketId = conversation._id;
            }

            if (this.cleanChatRef?.current) {
                await this.cleanChatRef.current.cleanUpSend();
            }
        });
    }

    handleRegisterSocketChats = (fn) => {
        this.setState({ socketChatsFn: fn });
    };

    handleChangeStatus(id){
        HttpClient("/conversation/status/change", "POST", {
            id: id,
            status: "open"
        })
            .catch((error) => {
                customToast.error("Error status change: " + error);
            })
    }

    handleChangeOnline(id, isOnline){
        HttpClient("/conversation/online", "POST", {
            conversationId: id || this.state.userActive_id,
            isOnline : isOnline
        })
    }

    handleReadMessage(conversationId){
        HttpClient("/chats/read/" + conversationId, "GET")
            .catch(() => {
                customToast.error("Error status read change");
            })
    }

    socketConversation = async (token) => {
        const URL = await CreateWebSocket("conversation/ws", token);
        const socket = new WebSocket(URL);

        this.socketRef.current = socket;

        socket.onopen = () => {
            this.getConversation();
            this.retryCountRef.current = 0;

            if (this.pingIntervalRef.current) {
                clearInterval(this.pingIntervalRef.current);
            }

            this.pingIntervalRef.current = setInterval(() => {
                if (socket.readyState === WebSocket.OPEN) {
                    this.socketRef.current.send(JSON.stringify({ type: "ping" }));
                }
            }, 60000);
        };

        socket.onmessage = (event) => {
            const receivedMessage = JSON.parse(event.data);

            if (
                receivedMessage.type !== "pong" &&
                receivedMessage.type !== "typing"
            ) {
                if (
                    receivedMessage.type === "conversation_updated" &&
                    receivedMessage.data.channel.channelId === this.state.dataChannelsId[0]
                ) {
                    {this.handleReadMessage(this.state.userActive_id)}

                    this.setState((prevState) => {
                        const prevConversations = prevState.conversations;
                        const updatedData = receivedMessage.data;

                        const existingConv = prevConversations.find(
                            (conv) => conv._id === updatedData._id
                        );

                        if (
                            !existingConv ||
                            JSON.stringify(existingConv) !== JSON.stringify(updatedData)
                        ) {
                            const updatedConversations = [
                                ...prevConversations.filter((conv) => conv._id !== updatedData._id),
                                updatedData
                            ].sort(
                                (a, b) => new Date(b.lastChatUpdate) - new Date(a.lastChatUpdate)
                            );

                            return {
                                conversations: updatedConversations,
                                conversation: updatedData
                            };
                        }

                        return null;
                    });
                }
            }
        };

        socket.onerror = (error) => {
        };

        socket.onclose = (event) => {
            if (this.retryCountRef.current < this.maxRetries) {
                const delay = Math.min(
                    1000 * Math.pow(2, this.retryCountRef.current),
                    this.retryDelay
                );

                setTimeout(() => {
                    this.retryCountRef.current += 1;
                    this.socketConversation(token);
                }, delay);
            } else {
                customToast.error(
                    "Max reconnection attempts reached. Please refresh the page to try again."
                );
            }
        };
    }

    socketChats = async (id, token) => {
        if (!id || !token) return;

        const params = { conversationId: id };
        const URL = await CreateWebSocket("chats/ws", token, params);
        const socket = new WebSocket(URL);

        this.socketRef.current = socket;

        socket.onopen = () => {
            this.retryCountRef.current = 0;
            this.setState({
                messagesData: [],
                openFile: false,
                fileList: [],
                text: ""
            });
        };

        socket.onmessage = (event) => {
            try {
                const receivedMessage = JSON.parse(event.data);

                if (receivedMessage?.status !== undefined && receivedMessage?.data?._id) {
                    if (receivedMessage.data._id === id) {
                        this.props.setNewConversation({
                            id: receivedMessage.data._id,
                            status: receivedMessage.data.status,
                            archived: receivedMessage.data.isArchived,
                            isOnline: this.state.nonAdminParticipants?.isOnline || false,
                            lastChatDate: receivedMessage.data.lastChatDate,
                        });
                    }
                } else {
                    const isTypingEvent = receivedMessage.type === "typing";
                    const isRelevantSender = receivedMessage.sender === this.typingSender;

                    if (isTypingEvent && isRelevantSender) {
                        this.setState({ isTyping: receivedMessage.isTyping });
                    } else if (
                        !isTypingEvent ||
                        receivedMessage?.type === 'chat_created' ||
                        receivedMessage?.type === 'conversation_updated' ||
                        receivedMessage?.type === 'initial_chat'
                    ) {
                        this.setState((prevState) => ({
                            ...prevState,
                            messagesData: receivedMessage,
                        }));
                    }
                }
            } catch (error) {
                console.error("WebSocket message parsing error:", error);
            }
        };

        socket.onerror = (error) => {
            console.error("WebSocket error:", error);
        };

        socket.onclose = () => {
            if (this.retryCountRef.current < this.maxRetries) {
                const delay = Math.min(1000 * Math.pow(2, this.retryCountRef.current), this.retryDelay);
                setTimeout(() => {
                    this.retryCountRef.current += 1;
                    this.socketChats(id, token);
                }, delay);
            }
        };
    };

    initChatApp = (token, user) => {
        this.setState({ messageAccount: user }, () => {
            this.getConversation();
            this.getChannels();
            this.socketConversation(token);
        });
    };

    componentDidMount() {
        const savedToken = localStorage.getItem("Presensi-message-token");
        const user = localStorage.getItem("Presensi-message-user");

        if (savedToken) {
            this.initChatApp(savedToken, JSON.parse(user));
        } else {
            this.getMessageToken();
        }

        this.generateRandom();
    }

    componentWillUnmount() {
        if (this.socketRef.current) {
            this.socketRef.current.close();
        }
        if (this.pingIntervalRef.current) {
            clearInterval(this.pingIntervalRef.current);
        }
    }

    render() {
        const { dataConversation } = this.state;

        if(['Admin'].indexOf(this.props.user.level) >= 0) {
            return (
                <Fragment>
                    <Breadcrumb title="Admin Chat Mitra" parent="Chat Mitra"/>
                    <div className="container-fluid">
                        <div className="row g-3">
                            <div className="col-md-5 mb-3">
                                <div className="card h-100 mb-0">
                                    <div className="card-header p-3 d-flex justify-content-between align-items-center">
                                        <h5 className="mb-0">Chats</h5>
                                        <p
                                            className="text-white mb-0"
                                            onClick={() => this.setState({modalNewChat: true})}
                                        >
                                            <div
                                                className="btn btn-primary px-2"
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    gap: 6,
                                                    fontSize: 12
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faPlus} style={{fontSize: 12}}/>
                                                <span>New Chat</span>
                                            </div>
                                        </p>
                                    </div>
                                    <div className="px-3 py-0">
                                        <div
                                            className="card-header d-flex justify-content-between align-items-center"
                                            style={{
                                                backgroundColor: "#F9F9F9",
                                                height: "36px",
                                                borderRadius: "6px",
                                                border: "1px solid #D1D5DB",
                                                padding: "6px 12px",
                                                fontSize: "14px",
                                                color: "#333",
                                                outline: "none",
                                            }}
                                        >
                                            <img
                                                src={search}
                                                alt="search"
                                                width={20}
                                                style={{cursor: 'pointer'}}
                                            />
                                            <input
                                                type="text"
                                                name="search"
                                                placeholder="Search chat..."
                                                value={this.state.search}
                                                onChange={this.handleSearchKeyword}
                                                onKeyDown={this.handleSearchKeyDown}
                                                className="col border-0"
                                                style={{
                                                    backgroundColor: "#F9F9F9",
                                                    border: "1px solid #D1D5DB",
                                                    padding: "2px 12px",
                                                    fontSize: "14px",
                                                    color: "#333",
                                                    outline: "none",
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <hr className="mb-0 mx-0"/>

                                    {this.state.loading &&
                                        <div
                                            className="p-3 mb-3"
                                            style={{
                                                height: '300px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            <p style={{textAlign: 'center', marginTop: 20, marginBottom: 20}}>
                                                <Spin size="large" style={{
                                                    width: '50%',
                                                    marginBottom: '10px',
                                                    marginTop: '10px'
                                                }}/>
                                            </p>
                                        </div>
                                    }

                                    {!this.state.loading && dataConversation.length === 0 ?(
                                        <div
                                            className="p-3 mb-3"
                                            style={{
                                                height: '300px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            <p style={{textAlign: 'center', marginTop: 20, marginBottom: 20}}>No more items</p>
                                        </div>
                                    ) : (
                                        !this.state.loading && (
                                            <div
                                                className="custom-scrollbar p-2 mb-3"
                                                style={{
                                                    height: 'auto',
                                                    minHeight: '362px',
                                                    maxHeight: '362px',
                                                    overflowY: 'auto'
                                                }}
                                            >
                                                <ChatScrollList
                                                    data={this.state.conversations}
                                                    renderItem={(conversation, index) => {
                                                        const {userActive_id, chatActive, messageAccount} = this.state;

                                                        const nonAdminParticipants = conversation.participants.find(
                                                            (member) => member.credential === "user"
                                                        );

                                                        const isUserRead = (item) => {
                                                            const participant = item.participants.find(
                                                                (p) => p.userID._id !== item.id
                                                            );

                                                            return participant.isRead;
                                                        };

                                                        const unreadCount = (conversation) => {
                                                            const participant = conversation.participants.find(
                                                                (p) => p.userID._id === messageAccount.id
                                                            );

                                                            return participant ? participant.unReadCount : 0;
                                                        }

                                                        return (
                                                            <div
                                                                key={conversation.id || index}
                                                                className="card-body p-3"
                                                                onClick={() =>
                                                                    this.handleOpenChat(conversation) ||
                                                                    this.handleConversationClick(conversation || nonAdminParticipants)
                                                                }
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    borderRadius: "10px",
                                                                    backgroundColor: (chatActive && userActive_id === conversation._id ? "#ebf3ff" : "#FFFFFF")
                                                                }}
                                                            >
                                                                <div className="d-flex justify-content-between align-items-start">
                                                                    <div className="d-flex align-items-start gap-3">
                                                                        {
                                                                            nonAdminParticipants?.image ? (
                                                                                <img
                                                                                    width={50}
                                                                                    height={50}
                                                                                    onError={(event) => {
                                                                                        event.target.onerror = null;
                                                                                        event.target.src = "";
                                                                                        event.target.style.display = "none";
                                                                                    }}
                                                                                    src={conversation.image}
                                                                                    alt="Company Logo"
                                                                                    className="rounded-circle mr-3"
                                                                                />
                                                                            ) : (
                                                                                <div
                                                                                    style={{
                                                                                        width: 50,
                                                                                        height: 50,
                                                                                        borderRadius: "50%",
                                                                                        backgroundColor: "#1890ff",
                                                                                        color: "white",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        fontWeight: "bold",
                                                                                        fontSize: "18px"
                                                                                    }}
                                                                                    className="mr-3"
                                                                                >
                                                                                    {nonAdminParticipants != undefined && nonAdminParticipants.name.charAt(0).toUpperCase() || "?"}
                                                                                </div>
                                                                            )
                                                                        }

                                                                        <div>
                                                                            <p className="mb-0 text-dark responsive-ellipsis"
                                                                               style={{
                                                                                   fontSize: "15px",
                                                                                   fontWeight: 500
                                                                               }}>
                                                                                {nonAdminParticipants != undefined
                                                                                    ? nonAdminParticipants.name
                                                                                    : "Tidak Ada Anggota"}
                                                                            </p>
                                                                            <div className="d-flex align-items-center">
                                                                                <p className="mb-0 ms-2 responsive-ellipsis"
                                                                                   style={{color: "#81788B"}}>
                                                                                    {conversation.lastChat ? conversation.lastChat : 'Image'}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <p className="mb-0 text-muted"
                                                                           style={{fontSize: '13px'}}>
                                                                            {moment(conversation.lastChatUpdate).isSame(moment(), 'day')
                                                                                ? moment(conversation.lastChatUpdate).format('HH:mm')
                                                                                : moment(conversation.lastChatUpdate).isSame(moment().subtract(1, 'days'), 'day') ?
                                                                                    'Kemarin'
                                                                                    : moment(conversation.lastChatUpdate).format('L')}
                                                                        </p>
                                                                        {conversation.status !== 'close' && !isUserRead(conversation) && unreadCount(conversation) !== 0 && (
                                                                            <button className="btn-presensi rounded-circle" style={{minWidth: '20px', minHeight: '20px'}}>
                                                                                <span style={{fontSize: "10px", color: "white"}}>
                                                                                    {unreadCount(conversation)}
                                                                                </span>
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>

                            <div className="col-md-7 mb-3">
                                {this.state.chatActive ? (
                                    <ChatCard
                                        token={localStorage.getItem("Presensi-message-token")}
                                        request={this.props.request}
                                        conversation={{
                                            id: this.state.userActive_id,
                                            status: this.state.userActive_status,
                                            archived: this.state.userActive_archived,
                                            isOnline: this.state.userActive_isOnline,
                                            lastChatDate: this.state.userActive_lastChatDate,
                                            dataParticipants: this.state.dataParticipants,
                                        }}
                                        participants={this.state.dataParticipants}
                                        typingSender={this.state.typingSender}
                                        handleChangeOnline={() => this.handleChangeOnline()}
                                        handleReadMessage={() => this.handleReadMessage()}
                                        setNewConversation={(newData) => {
                                            this.setState({
                                                id: newData.id,
                                                status: newData.status,
                                                archived: newData.archived,
                                                isOnline: newData.isOnline,
                                                lastChatDate: newData.lastChatDate,
                                            });
                                        }}
                                        handleClose={this.handleCloseChat}
                                        registerSocketChats={this.handleRegisterSocketChats}
                                    />
                                ) : (
                                    <div
                                        className="card h-100 mb-0 d-flex justify-content-center align-items-center text-center">
                                        <div className="container-fluid">
                                            <p className="mb-0">Select chat to view details.</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {this.state.modalNewChat ? (
                        <Modal style={{ minWidth: "600px" }} showOverlay={true} showCloseButton={false}>
                            <Modal.Header>
                                <Modal.Title style={{ fontWeight: "bold" }}>
                                    New Chat
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="form-group row mb-0">
                                    <label className="flex align-items-center col-xl-4 col-md-5 mb-0 mt-2"><span>*</span> Perusahaan</label>
                                    <AsyncPaginate
                                        className="col-xl-8 col-md-7"
                                        placeholder="Cari Perusahaan"
                                        isClearable
                                        debounceTimeout={300}
                                        value={this.state.selectedCompany}
                                        loadOptions={this.loadCompanyOptions}
                                        additional={{ page: 1 }}
                                        onChange={(selected) => {
                                            if (selected) {
                                                this.loadDetail(selected.value);
                                                this.handleChange({ target: { name: 'select_company', value: selected.value } });
                                                this.setState({ selectedCompany: selected });
                                            } else {
                                                this.setState({ selectedCompany: null });
                                            }
                                        }}
                                    />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button1 onClick={() => this.toggleModal()}>Batal</Button1>
                                <Button1 onClick={this.registerCustomer} disabled={this.state.perusahaan_email === "" || this.state.perusahaan_email === null || this.state.selectedCompany === "" || this.state.selectedCompany === null}>Add</Button1>
                            </Modal.Footer>
                        </Modal>
                    ) : null
                    }
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <h5 className="text-center pt-4">Anda tidak punya akses ke halaman ini.</h5>
                </Fragment>
            )
        }

    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatMitra);
